import { keys } from "shared/theme/sidespor/utility";
import { darkTheme } from "shared/theme/sidespor/theme/darkTheme";
import { lightTheme } from "shared/theme/sidespor/theme/lightTheme";

/**
 * Example:
 *
 * --- Output looks like this ---
 * {
 *  colors: {
 *    semantics: {
 *      colorAlarm: {
 *        value: {
 *          _light: lightTheme[colorAlarm]
 *          _dark: darkTheme[colorAlarm]
 *        }
 *      }
 *      colorInfo: {
 *        value: {
 *          _light: lightTheme[colorInfo]
 *          _dark: darkTheme[colorInfo]
 *        }
 *      }
 *      ...
 *    }
 *  }
 * }
 * ---------------------------------
 *
 * Docs: https://chakra-ui.com/docs/theming/semantic-tokens
 */
export const semanticTokens = {
  colors: {
    semantics: Object.fromEntries(
      keys(lightTheme).map((key) => [
        [key],
        { value: { _light: lightTheme[key], _dark: darkTheme[key] } },
      ]),
    ),
  },
};
